import script from "./UploadVideoGeoblockRuleSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadVideoGeoblockRuleSetting.vue?vue&type=script&setup=true&lang=ts"

import "./UploadVideoGeoblockRuleSetting.vue?vue&type=style&index=0&id=5a4e0ca5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a4e0ca5"]])

export default __exports__